import { findSameGiftItem } from "../../../api/helpers/shoppingCartHelper";
import { couponCalculator } from "./../../../api/services/CouponCalculatorService";
const state = {
  cartItems: [],
  deliveryFee: 0,
  isDelivery: false,
  coupons: [],
  couponStoreIds: [],
};

export const mutations = {
  giftIsDelivery(state, isDelivery) {
    state.isDelivery = isDelivery;
  },
  Add_GiftcartItem(state, { item, quantity, message }) {
    let now = new Date();
    const records = state.cartItems.filter(element => element.id == item.id);
    let same = true;
    let find = null;
    if (records.length > 0) {
      find = findSameGiftItem(item, message, records);
      if (!find) {
        same = false;
      }
    } else {
      same = false;
    }
    if (!same) {
      state.cartItems.push({
        ...item,
        quantity,
        message,
        created: now.toUTCString()
      });
    } else {
      find.quantity += quantity;
      find.created = new Date().toUTCString();
    }
  },
  Set_GiftItems(state, items) {
    if (items) {
      state.cartItems = items;
    }
  },
  REMOVE_GIFTCART_ITEM(state, { item }) {
    const record = state.cartItems.find(element => element.id == item.id);
    state.cartItems.splice(state.cartItems.indexOf(record), 1);
  },
  UpdateGiftItemQuantity(state, { item, quantity, message }) {
    const records = state.cartItems.filter(element => element.id == item.id);
    let same = true;
    let find = null;
    if (records.length > 0) {
      find = findSameGiftItem(item, message, records);
      if (!find) {
        same = false;
      }
      if (same) {
        find.quantity = quantity;
        if (quantity == 0) {
          state.cartItems.splice(state.cartItems.indexOf(find), 1);
        }
      }
    }
  },
  add_coupon_to_GiftCart(state, payload) {
    const { coupon, storeId } = payload;
    state.coupons.push(coupon);
    state.couponStoreIds.push(storeId);
  },
  Clear_Coupon_GiftCart_Items(state) {
    state.coupons = [];
    state.couponStoreIds = [];
  },
  remove_coupon_from_GiftCart_Cart(state, couponCode) {
    const record = state.coupons.find(
      element => element.CouponCode == couponCode
    );
    const index = state.coupons.indexOf(record);
    state.coupons.splice(index, 1);
    state.couponStoreIds.splice(index, 1);
  },
  remove_coupons_of_other_stores(state, storeId) {
    let index = state.coupons.length;
    while(index > -1) {
      index = state.couponStoreIds.findIndex(e => e != storeId);
      if(index > -1) {
        state.coupons.splice(index, 1);
        state.couponStoreIds.splice(index, 1);
      }
    }
  },
};

export const actions = {
  giftFilterCoupons: ({ commit, getters }, storeId) => {
    const coupons = getters.giftCoupons;
    const storeIds = getters.getGiftCouponStoreIds;

    if(coupons.length != storeIds.length) {
      commit("Clear_Coupon_GiftCart_Items");
    }

    commit("remove_coupons_of_other_stores", storeId);
  },
  clearGiftCart: ({ commit }) => {
    commit("Set_GiftItems", []);
    commit("Clear_Coupon_GiftCart_Items");
  },
  clearGiftCoupon: ({ commit }) => {
    commit("Clear_Coupon_GiftCart_Items");
  },
  addCouponToCart: ({ commit }, payload) => {
    commit("add_coupon_to_GiftCart", payload);
  },
  removeCouponfromCart: ({ commit }, coupon) => {
    commit("remove_coupon_from_GiftCart_Cart", coupon);
  }
};

export const getters = {
  giftIsDelivery: state => {
    return state.isDelivery;
  },
  giftCartItems: state => {
    let copy = [...state.cartItems];
    return copy.sort((a, b) => {
      return new Date(b.created) - new Date(a.created);
    });
  },
  giftCartTotalQuantity: state => {
    let copy = [...state.cartItems];
    let totalQuantity = 0;
    copy.forEach(element => {
      totalQuantity += Number(element.quantity);
    });
    return totalQuantity;
  },
  giftTotalPrice: (state, getters) => {
    let res = 0;
    state.cartItems.map(item => {
      res += item.price * item.quantity;
    });
    res = res + getters.getGiftSurchargeAmount - getters.giftDiscount;
    return res;
  },
  giftDiscount: state => {
    var result = couponCalculator.calcAllCoupons(
      state.coupons,
      state.cartItems
    );
    return result;
  },
  giftUsedCoupons: state => {
    couponCalculator.calcAllCoupons(state.coupons, state.cartItems);
    return couponCalculator.used_Coupons;
  },
  giftCoupons: state => {
    return state.coupons;
  },
  getGiftCouponStoreIds: state => {
    return state.couponStoreIds;
  },
  giftCartValue: state => {
    let res = 0;
    state.cartItems.map(item => {
      res += item.price * item.quantity;
    });
    return res;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
